// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__11TNn","dragIcon":"Choice_dragIcon__U4p-J","left":"Choice_left__2DtXe","input":"Choice_input__Rxdi-"};